import { render, staticRenderFns } from "./PttAvmKategori.vue?vue&type=template&id=f48076b0&scoped=true"
import script from "./PttAvmKategori.vue?vue&type=script&lang=js"
export * from "./PttAvmKategori.vue?vue&type=script&lang=js"
import style0 from "./PttAvmKategori.vue?vue&type=style&index=0&id=f48076b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48076b0",
  null
  
)

export default component.exports